import React from 'react'
import DefaultSettingManagement from './abstract/DefaultSettingManagement'

import StyleAdmin from '../../../style/StyleAdmin'
import Window from '../../../../common/Window'
import Loading from '../../../../common/component/Loading'

class SekkeiUnitPriceSetting extends DefaultSettingManagement {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false, offset: false}
    this.systemSettingName = 'SekkeiUnitPriceSetting'
  }
  onInsert (offset) {
    offset = Number(offset)
    const SekkeiUnitPriceSetting = this.getSettingData()
    const lastSekkeiUnitPriceSetting = SekkeiUnitPriceSetting[offset]
    SekkeiUnitPriceSetting.splice(offset + 1, 0,
      {
        startMonth: lastSekkeiUnitPriceSetting.startMonth + 100,
        endMonth: lastSekkeiUnitPriceSetting.endMonth + 100,
        sekkeiUnitPriceList: [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0
        ]
      }
    )
    this.setState({
      offset: offset + 1,
      SekkeiUnitPriceSetting: SekkeiUnitPriceSetting,
      SekkeiUnitPriceSettingInputData: JSON.parse(JSON.stringify(SekkeiUnitPriceSetting))
    })
  }
  onDelete (offset) {
    if (this.getSettingData().length > 1) {
      Window.confirm('この行を削除してもよろしいですか?', () => {
        offset = Number(offset)
        const SekkeiUnitPriceSetting = this.getSettingData()
        SekkeiUnitPriceSetting.splice(offset, 1)
        this.setState({
          offset: false,
          SekkeiUnitPriceSetting: SekkeiUnitPriceSetting,
          SekkeiUnitPriceSettingInputData: JSON.parse(JSON.stringify(SekkeiUnitPriceSetting))
        })
        Window.closeDialog()
      })
    }
  }
  onMoveUp (offset) {
    offset = Number(offset)
    if (offset > 0) {
      const SekkeiUnitPriceSetting = this.getSettingData()
      SekkeiUnitPriceSetting.splice(offset - 1, 2, SekkeiUnitPriceSetting[offset], SekkeiUnitPriceSetting[offset - 1])
      this.setState({
        SekkeiUnitPriceSetting: SekkeiUnitPriceSetting,
        SekkeiUnitPriceSettingInputData: JSON.parse(JSON.stringify(SekkeiUnitPriceSetting))
      })
    }
  }
  onMoveDown (offset) {
    offset = Number(offset)
    const SekkeiUnitPriceSetting = this.getSettingData()
    if (offset < SekkeiUnitPriceSetting.length - 1) {
      offset++
      SekkeiUnitPriceSetting.splice(offset - 1, 2, SekkeiUnitPriceSetting[offset], SekkeiUnitPriceSetting[offset - 1])
      this.setState({
        SekkeiUnitPriceSetting: SekkeiUnitPriceSetting,
        SekkeiUnitPriceSettingInputData: JSON.parse(JSON.stringify(SekkeiUnitPriceSetting))
      })
    }
  }
  changed (index, attributeName, e) {
    const SekkeiUnitPriceSetting = this.state.SekkeiUnitPriceSetting
    SekkeiUnitPriceSetting[index][attributeName] = parseInt(e.target.value)
    this.setState({
      SekkeiUnitPriceSetting: SekkeiUnitPriceSetting,
      SekkeiUnitPriceSettingInputData: JSON.parse(JSON.stringify(SekkeiUnitPriceSetting))
    })
  }
  changePrefectureData (monthOffset, prefectureOffset, e) {
    const SekkeiUnitPriceSetting = this.state.SekkeiUnitPriceSetting
    const SekkeiUnitPriceSettingInputData = this.state.SekkeiUnitPriceSettingInputData
    let changedValue = e.target.value

    // 整数と、少点数以外を除く
    changedValue = changedValue.replace(/[^0-9.]/g, '')
    // input用データ
    SekkeiUnitPriceSettingInputData[monthOffset].sekkeiUnitPriceList[prefectureOffset] = changedValue
    // 保存用データ（整数にする）
    SekkeiUnitPriceSetting[monthOffset].sekkeiUnitPriceList[prefectureOffset] = parseInt(changedValue)
    this.setState({
      SekkeiUnitPriceSetting: SekkeiUnitPriceSetting,
      SekkeiUnitPriceSettingInputData: SekkeiUnitPriceSettingInputData
    })
  }
  onSwitchTerm (offset) {
    this.setState({
      offset: offset
    })
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const SekkeiUnitPriceSetting = this.getSettingData()
    const SekkeiUnitPriceSettingInputData = this.state.SekkeiUnitPriceSettingInputData
    const yearMonthList = this.getYMList(6, 201509, '%s年%s月適用分').reverse()
    const yearMonthListToShow = yearMonthList.map(ym => {
      return (
        <option key={ym.id} value={ym.id}>{ym.name}</option>
      )
    })
    const PrefectureList = this.getPrefectureList()
    let PrefectureTable = []
    if (this.state.offset !== false) {
      const PrefectureListToShow = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((row) => { // forだと誤作動
        return (
          <tr key={this.state.offset * 100 + row}>
            <th className='kw-ds-no'>{PrefectureList[row].id}</th><th className='kw-text-pl5'>{PrefectureList[row].name}</th><td><input type='text' value={Number(SekkeiUnitPriceSettingInputData[this.state.offset].sekkeiUnitPriceList[row]).toFixed(0)} onChange={(e) => this.changePrefectureData(this.state.offset, row, e)} /></td>
            <th className='kw-ds-no'>{PrefectureList[row + 10].id}</th><th className='kw-text-pl5'>{PrefectureList[row + 10].name}</th><td><input type='text' value={Number(SekkeiUnitPriceSettingInputData[this.state.offset].sekkeiUnitPriceList[row + 10]).toFixed(0)} onChange={(e) => this.changePrefectureData(this.state.offset, (row + 10), e)} /></td>
            <th className='kw-ds-no'>{PrefectureList[row + 20].id}</th><th className='kw-text-pl5'>{PrefectureList[row + 20].name}</th><td><input type='text' value={Number(SekkeiUnitPriceSettingInputData[this.state.offset].sekkeiUnitPriceList[row + 20]).toFixed(0)} onChange={(e) => this.changePrefectureData(this.state.offset, (row + 20), e)} /></td>
            <th className='kw-ds-no'>{PrefectureList[row + 30].id}</th><th className='kw-text-pl5'>{PrefectureList[row + 30].name}</th><td><input type='text' value={Number(SekkeiUnitPriceSettingInputData[this.state.offset].sekkeiUnitPriceList[row + 30]).toFixed(0)} onChange={(e) => this.changePrefectureData(this.state.offset, (row + 30), e)} /></td>
            <th className='kw-ds-no'>{(row + 40 < 47) ? PrefectureList[row + 40].id : ''}</th><th className='kw-text-pl5'>{(row + 40 < 47) ? PrefectureList[row + 40].name : ''}</th>
            <td><input type='text' value={(row + 40 < 47) ? Number(SekkeiUnitPriceSettingInputData[this.state.offset].sekkeiUnitPriceList[row + 40]).toFixed(0) : ''} style={{display: (row + 40 < 47) ? 'inline' : 'none'}} onChange={(e) => this.changePrefectureData(this.state.offset, (row + 40), e)} /></td>
          </tr>
        )
      })

      const startMonth = SekkeiUnitPriceSetting[this.state.offset].startMonth
      const endMonth = SekkeiUnitPriceSetting[this.state.offset].endMonth
      // keyをセットしないと切り替わらない
      PrefectureTable = (
        <div key={this.state.offset}>
          <h6 className='alert alert-block alert-success'>【No.{this.state.offset + 1}】 :
            {Math.floor(startMonth / 100) + '年' + (startMonth % 100) + '月'} - {Math.floor(endMonth / 100) + '年' + (endMonth % 100) + '月'} の 都道府県毎の設計労務単価</h6>
          <table className='kw-ds-detail-tbl'>
            <thead>
              <tr>
                <th className='kw-ds-no' />
                <th className='kw-ds-pref-name' />
                <th className='kw-ds-sekkei-unit-price' />
                <th className='kw-ds-no' />
                <th className='kw-ds-pref-name' />
                <th className='kw-ds-sekkei-unit-price' />
                <th className='kw-ds-no' />
                <th className='kw-ds-pref-name' />
                <th className='kw-ds-sekkei-unit-price' />
                <th className='kw-ds-no' />
                <th className='kw-ds-pref-name' />
                <th className='kw-ds-sekkei-unit-price' />
                <th className='kw-ds-no' />
                <th className='kw-ds-pref-name' />
                <th className='kw-ds-sekkei-unit-price' />
              </tr>
            </thead>
            <tbody>
              {PrefectureListToShow}
            </tbody>
          </table>
        </div>
      )
    }
    const SekkeiUnitPriceSettingToShow = SekkeiUnitPriceSetting.map((kenkou, index, list) => {
      const isTop = (index === 0)
      const isBottom = (index === list.length - 1)
      const isOnlyOne = (list.length <= 1)
      return (
        <tr key={index}>
          <th className='kw-ds-no'>{index + 1}</th>
          <td><select value={kenkou.startMonth} ref={'startMonth' + index} onChange={(e) => this.changed(index, 'startMonth', e)}>{yearMonthListToShow}</select></td>
          <td><select value={kenkou.endMonth} ref={'endMonth' + index} onChange={(e) => this.changed(index, 'endMonth', e)} >{yearMonthListToShow}</select></td>
          <td className='kw-ds-sekkei-unit-price'><a onClick={this.onSwitchTerm.bind(this, index)}>編集</a></td>
          <td className='kw-ds-gyou-sousa-icons'>
            <span className='text-success'><i className='icon-plus-sign kw-pointer' onClick={this.onInsert.bind(this, index)} /></span>
            <span className='text-error'><i className='icon-minus-sign' onClick={this.onDelete.bind(this, index)}
              style={isOnlyOne ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(185, 74, 72)', cursor: 'pointer'}} /></span>
            <span className='text-info'><i className='icon-circle-arrow-up' style={isTop ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveUp.bind(this, index)} /></span>
            <span className='text-info'><i className='icon-circle-arrow-down' style={isBottom ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveDown.bind(this, index)} /></span>
          </td>
        </tr>
      )
    })
    return (
      <form id='userSecurityForm' className='form-horizontal' method='post' onSubmit={this.onSubmit.bind(this)}>
        <div className='row'>
          <fieldset className='kw-ds-regist-area span16'>
            <legend>設計労務単価</legend>
            <div className='alert alert-block alert-info'>
              <p>
                必要な情報を入力して最後に「登録」ボタンを押してください。
              </p>
            </div>
            <table>
              <thead>
                <tr>
                  <th className='kw-ds-no' />
                  <th className='kw-ds-start-month' />
                  <th className='kw-ds-end-month' />
                  <th className='kw-ds-sekkei-unit-price' />
                  <th className='kw-ds-gyou-sousa' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th style={StyleAdmin.defaultSetting.textCenter}>No.</th>
                  <th className='kw-ds-start-month'>適用開始年月</th>
                  <th className='kw-ds-end-month'>適用終了年月</th>
                  <th style={StyleAdmin.defaultSetting.textCenter}>設計労務単価</th>
                  <th style={StyleAdmin.defaultSetting.textCenter}>行操作</th>
                </tr>
                {SekkeiUnitPriceSettingToShow}
              </tbody>
            </table>
            {PrefectureTable}
            <footer id='submit-actions' className='form-actions'>
              <button id='submit-button' type='submit' className='btn btn-primary' name='action' value='CONFIRM'>登録</button>
            </footer>
          </fieldset>
        </div>
      </form>
    )
  }
}
export default SekkeiUnitPriceSetting



// WEBPACK FOOTER //
// ./src/admin/pages/secure/DefaultSetting/SekkeiUnitPriceSetting.js